'use client';

import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import useHeaderMenu, { type IUseHeaderMenuProps } from './useHeaderMenu';

type HeaderMenuContextType = ReturnType<typeof useHeaderMenu>;

export const HeaderMenuContext = createContext<HeaderMenuContextType | null>(null);

export const useHeaderMenuContext = (): HeaderMenuContextType => {
  const context = useContext(HeaderMenuContext);

  if (!context) {
    throw new Error('useHeaderMenuContext must be used within HeaderMenuProvider');
  }

  return context;
};

interface IProps extends PropsWithChildren {
  headerMenu: IUseHeaderMenuProps,
}

export const HeaderMenuProvider = ({ children, headerMenu }: IProps): ReactElement => (
  <HeaderMenuContext.Provider value={ useHeaderMenu(headerMenu) }>
    { children }
  </HeaderMenuContext.Provider>
);
